import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from '@app/layout/page-layout.component';
import { AuthGuard } from '@auth0/auth0-angular';
import { LogoutComponent } from './pages';
import { AppAccesshGuardService } from './core/guards';
import { TokenService } from './shared/services/token.service';
import { SessionService } from './shared/helpers';
import { AcountsComponent } from './account-layout/acounts.component';
import { CallbackComponent } from './core/components';
import { CustomPreloadingStrategyService } from './core/services';

const routes: Routes = [
  {
    path: '',
    component: CallbackComponent,
    pathMatch: 'full',
  },
  {
    path: 'account',
    component: AcountsComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/accounts/accounts.module').then((m) => m.AccountsModule),
      },
    ],
  },
  {
    path: 'auth0',
    component: LayoutComponent,
    canActivate: [AuthGuard, AppAccesshGuardService],
    children: [
      {
        path: 'admin',
        data: { preload: true, loadAfterSeconds: 10 },
        loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
      },
    ],
  },
  { path: 'logout', component: LogoutComponent, pathMatch: 'full' },
  {
    path: '**',
    redirectTo: 'login',
    pathMatch: 'full',
  },
];

const config: ExtraOptions = {
  useHash: false,
  preloadingStrategy: CustomPreloadingStrategyService,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(private tokenService: TokenService, private sessionService: SessionService) {
    if (this.sessionService.getApplicationToken()) {
      this.tokenService.checkSession(true);
    }
  }
}
